import React from 'react';

const CEFMessage = ({ icon, text, classNames }) => (
  <div className={`cef-message ${classNames ? classNames : ''}`}>
    {icon && (
      <img
        className="cef-message__icon"
        src={icon}
        width={20}
        height={20}
        alt=""
      />
    )}

    <p className="cef-message__text">{text}</p>
  </div>
);

export default CEFMessage;
